import React from "react";
import { FormattedMessage } from "react-intl";

export default [
    {
        name: "nameAr",
        label: <FormattedMessage id="branch-form.arabic-name" />,
        type: "string",
        errorMessage: <FormattedMessage id="branch-form.err-msg-arabic-name" />,
        validation: {
            required: true,
        },
    },
    {
        name: "nameEn",
        label: <FormattedMessage id="branch-form.english-name" />,
        type: "string",
        errorMessage: <FormattedMessage id="branch-form.err-msg-english-name" />,
        validation: {
            required: true,
        },
    },
    {
        name: "organizationId",
        label: <FormattedMessage id="branch-form.client" />,
        type: "list",
        helpText: <FormattedMessage id="branch-form.help-txt-client" />,
        url: "/organizations",
        filterValue: "name",
        errorMessage: <FormattedMessage id="branch-form.err-msg-client" />,
        validation: {
            required: true,
        },
        entityName: "organization",
        include: true,
    },
    {
        name: "locationId",
        label: <FormattedMessage id="branch-form.location" />,
        type: "list",
        helpText: <FormattedMessage id="branch-form.help-txt-location" />,
        url: "/locations",
        filterValue: "name",
        errorMessage: <FormattedMessage id="branch-form.err-msg-location" />,
        validation: {
            required: true,
        },
        entityName: "location",
        itemLabels: ["name", "cityName"],
        include: true,
    },
    {
        name: "adminUserIds",
        label: <FormattedMessage id="branch.admin-user" />,
        type: "list",
        helpText: <FormattedMessage id="branch-form.help-txt-admin-user" />,
        url: "/admin-users",
        filterValue: "email",
        isMultiple: true,
        entityName: "adminUsers",
        include: true,
    },
];
